import React from 'react'
import {HealthStatusIndicator} from '@/ui/components/HealthStatusIndicator'

export const StatusPage: React.FC = () => {
  return (
    <div className='ob-page' style={{paddingTop: 'var(--ob-spacing-3)'}}>
      <div className='card-header border-0 pt-3' style={{minHeight: '80px'}}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start'}}>
          <h3>System Status</h3>
          <h5 style={{color: 'grey', alignContent: 'center'}}>
            Monitor the health of OmicsBox services and infrastructure
          </h5>
        </div>
      </div>

      <div className='ob-page__section'>
        <HealthStatusIndicator showDetails={true} />
      </div>
    </div>
  )
}
